import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function createItemId() {
  const pg = globalThis.crypto;
  if (pg?.randomUUID) {
    return pg.randomUUID();
  }

  return Math.random().toString(36).slice(2);
}
